module.exports = __webpack_public_path__ + "8f8cba3b6d201ff8555d69d7d32695f8.png";